export const MobileBottomNavHeight = 44;
export const FrameHeaderHeight = 32;
export const FrameSidebarWidth = 40;
export const MobileFrameHeaderHeight = 40;
